import { FC } from 'react';

export interface SpinnerProps {
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  color?: 'brand' | 'white' | 'slate' | 'rose' | 'amber';
  className?: string;
  label?: string;
}

const sizeClasses = {
  xs: 'w-3 h-3 border-2',
  sm: 'w-4 h-4 border-2',
  md: 'w-6 h-6 border-2',
  lg: 'w-8 h-8 border-3',
  xl: 'w-10 h-10 border-4',
};

const colorClasses = {
  brand: 'border-emerald-500/20 border-t-emerald-500',
  white: 'border-white/20 border-t-white',
  slate: 'border-slate-700 border-t-slate-300',
  rose: 'border-rose-500/20 border-t-rose-500',
  amber: 'border-amber-500/20 border-t-amber-500',
};

export const Spinner: FC<SpinnerProps> = ({
  size = 'md',
  color = 'brand',
  className = '',
  label = 'Carregando...',
}) => {
  return (
    <div
      role="status"
      className="inline-flex items-center gap-2"
      aria-label={label}
    >
      <div
        className={`animate-spin rounded-full ${sizeClasses[size]} ${colorClasses[color]} ${className}`}
      />
      <span className="sr-only">{label}</span>
    </div>
  );
};
